import React, {Component} from 'react'

export default class Termos extends Component {
  render() {
    return (
      <div>
        <section className="py-5">
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h1>Termos de uso e política de privacidade</h1>
              </div>
            </div>
          </div>

          <div className="container">
            <p>
              O objetivo do “projeto Meia Entrada” é atender a Portaria nº 2 de 05 de maio de 2016 expedida pelo
              Instituto Nacional de Tecnologia da Informação – ITI, bem como a Lei nº 12.933, de 26 de dezembro de 2013
              (“Lei da Meia Entrada Estudantil”), criando um ambiente que permita aos estabelecimentos públicos e
              privados a comprovação da condição estudantil daqueles que fazem jus ao pagamento da metade do preço do
              ingresso efetivamente cobrado do público em geral no acesso a salas de cinema, cineclubes, teatros,
              espetáculos musicais e circenses e eventos educativos, esportivos, de lazer e de entretenimento, em todo o
              território nacional, por meio de uma Carteira de Identificação Estudantil – CIE,
            </p>

            <p>
              Para fins deste Termo de Uso entende-se por:
            </p>

            <p>
              Carteira de Identificação Estudantil – CIE: documento que comprova a condição de estudante regularmente
              matriculado nos níveis e modalidades de educação e ensino previstos no Título V da Lei nº 9.394, de 1996,
              conforme modelo único nacionalmente padronizado, com certificação digital e que pode ter cinquenta por
              cento de características locais.
            </p>

            <p>
              Validador da CIE: é o aplicativo de celular, site, API e infra-estrutura, utilizados para validar os diferentes certificado de atributos das CIEs, 
              independente da entidade estudantil responsável pela emissão, seguindo a premissa que a mesma seja conveniada e tenha enviado os documentos e certificados digitais necessários para inclusão no sistema de validação.
              O sistema de validação permite aos emissores (Entidades estudantis conveniadas) de CIE, que incluam os seus respectivos certificados que devem ser utilizados no processo validação (API, App e sites).
              Para suportar o processo de integração dos emissores, fornecemos ferramentas para inclusão dos certificados emitidos/revogadas, documentação cadastral e chaves de acesso as APIs.
            </p>

            <p>
              Entidade emissora: entidades estudantis que emitem a CIE.
            </p>

            <p>
              Integração validador: é o conjunto de ferramentas para permitir que estabelecimentos possam consultar se
              uma determinada CIE é válida ou não.
            </p>

            <p>
              Estabelecimentos: estabelecimentos públicos e privados promotores de eventos destinados a salas de cinema,
              cineclubes, teatros, espetáculos musicais e circenses e eventos educativos, esportivos, de lazer e de
              entretenimento, em todo o território nacional.
            </p>

            <p>
              Estudante: pessoa regularmente matriculada em instituição de ensino, pública ou privada, nos níveis e
              modalidades previstos no Título V da Lei nº 9.394, de 20 de dezembro de 1996 - Lei de Diretrizes e Bases
              da Educação Nacional.
            </p>

            <p>
              Certificado de atributo: Tecnologia disponível a partir do sistema de Certificação Digital padrão
              ICP-Brasil, padronizado no DOC-ICP-16 e DOCI-ICP-16.01, conforme definição técnica contida no Padrão
              Nacional para emissão e validação da Carteira de Identificação Estudantil expedido anualmente pelas
              entidades nacionais de representação estudantil Associação Nacional de Pós-Graduandos – ANPG, União
              Nacional dos Estudantes – UNE, e União Nacional dos Estudantes Secundaristas – UBES.
            </p>

            <p>
              <b>VALIDAÇÃO UNIFICADA DAS CIES</b>
            </p>

            <p>
              Sempre que for emitida uma nova CIE, o certificado de atributo da mesma deve ser assinado pelo certificado A3 que pertence entidade emissora.
              Para que o validador oficial da meia entrada consiga validar o certificado de atributo da CIE, o certificado A3 da emissora deve ser enviado para o nosso repositório de certificados para conseguirmos validar a assinatura do certificado de atributo.
            </p>

            <p>
              <b>DA VALIDAÇÃO DE UMA CIE</b>
            </p>

            <p>
              Sempre que um estabelecimento comercializar ingresso/entrada com o desconto baseado na “Lei da Meia
              Entrada”, deverá autenticar a CIE do protador do ingresso/entrada através do validador disponível no
              portal da Meia Entrada.
            </p>

            <p>
              <b>DA POLÍTICA DE PRIVACIDADE</b>
            </p>

            <p>
              A Política de Privacidade do site do MeiaEntrada.org na internet ratifica o compromisso da Instituição com
              as suas diretrizes, em especial, a consistência, a transparência e o profissionalismo.
            </p>

            <p>
              Este documento objetiva esclarecer os usuários do site sobre os itens dessa política, em especial, quanto
              ao conteúdo dos registros efetuados, ao tratamento das informações coletadas e ao uso de cookies.
            </p>

            <p>
              Conteúdo dos registros
            </p>

            <p>
              Quando um usuário acessa o site da MeiaEntrada.org, são disponibilizadas as seguintes informações:
            </p>

            <ul>
              <li>
                data e hora dos acessos;
              </li>
              <li>
                páginas visitadas;
              </li>
              <li>
                tipo de navegador;
              </li>
              <li>
                endereço de IP;
              </li>
              <li>
                ação que o usuário tentou executar (download de um documento, por exemplo) e se obteve êxito; e
              </li>
              <li>
                endereço de outro site, caso o acesso ao site do Banco Central do Brasil se verifique por meio de link.
              </li>
            </ul>

            <p>
              Podem ser registradas as seguintes informações relativas a mensagens eletrônicas:
            </p>

            <ul>
              <li>
                e-mail;
              </li>
              <li>
                nome do usuário;
              </li>
              <li>
                localização do usuário (cidade, estado e país);
              </li>
              <li>
                assunto;
              </li>
              <li>
                conteúdo da mensagem; e
              </li>
              <li>
                endereço de IP.
              </li>
            </ul>

            <p>
              <b>DO TRATAMENTO DAS INFORMAÇÕES</b>
            </p>

            <ol style={{"list-style-type": "lower-alpha"}}>
              <li>
                <p>
                  As informações dos usuários que são consultadas pelo site MeiaEntrada.org.br, pela nossa API ou pelo aplicativo de celular,
                  são utilizada apenas para efeito de verificação do validade da CIE em tempo real, nenhum informação fornecida é armazenada/arquivada, para garantir
                  segurança, confidencialidade e integridade dos dados.
                </p>
              </li>

              <li>
                <p>
                  As informações de caráter pessoal ou confidencial são tratadas por servidores especializados e
                  treinados, de acordo com preceitos éticos, legais e morais. O fornecimento dessas informações a
                  terceiros ou a sua utilização para finalidades diversas daquelas para as quais foram coletadas somente
                  ocorrerá mediante determinação legal ou judicial. Os servidores que, por qualquer motivo, usarem
                  indevidamente essas informações estão sujeitos às penalidades e às sanções legais e disciplinares. 
                </p>
              </li>
            </ol>

            <p>
              <b>DO USO DE COOKIES</b>
            </p>

            <p>
              A utilização de cookies pelo site da MeiaEntrada.org objetiva facilitar a navegação e a adequação do site
              às preferências dos usuários. Essa utilização não visa monitorar ou identificar as ações dos usuários. É
              importante ressaltar que o usuário pode, a qualquer momento, utilizar recursos do seu navegador para
              bloquear a instalação dos cookies ou para informar quando estão ativados, sem prejuízo para a navegação do
              site.
            </p>

            <p>
              A MeiaEntrada.Org não se responsabiliza pelas informações disponíveis nos sites externos indicados por
              meio de links e pelas respectivas políticas de privacidade, em especial, quanto à utilização de cookies.
            </p>

            <p>
              As empresas, organizações e instituições contratadas para realizar serviços relacionados ao site da
              MeiaEntrada.org devem observar a nossa Política de Privacidade e a ela se adequar.
            </p>

            <p>
              As dúvidas referentes à nossa Política de Privacidade podem ser encaminhadas através do Fale Conosco.
            </p>
          </div>
        </section>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/views/Termos/Termos.js